// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const TopPlayersSection = styled.div`
`;

const TopPlayersSectionComponent = ({ children }) => {
    return <TopPlayersSection>{children}</TopPlayersSection>;
};

export default TopPlayersSectionComponent;
